module.exports = __webpack_public_path__ + "website/img/je-mall.7cd2fcb7.svg";